import { TableColumnsSetting } from '@/interfaces/table-setting';
import { TestDriveModel } from '@/models/test-drive/test-drive.model';

export class TestDriveTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof TestDriveModel> {
    return [
      {
        name: 'btnDetails',
        customComponent: true,
        unsortable: true,
      },
      {
        name: 'btnDelete',
        customComponent: true,
        unsortable: true,
      },
      {
        name: 'id',
        text: 'ID',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataInizioTestDrive',
        text: 'Data Test Drive',
        type: 'datetime',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'marca',
        text: 'Marca',
        type: 'object',
        propertyToShow: 'descrizioneMarca',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'modello',
        text: 'Modello',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'targa',
        text: 'Targa',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'telaio',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazioneCliente',
        text: 'Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataNascita',
        text: 'Data di Nascita',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'numeroPatente',
        text: 'Numero Patente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'creator',
        text: 'Creato da',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'created',
        type: 'datetime',
        text: 'Creato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
